import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery, useTheme } from "@mui/material";
import { AddressesText } from "../../Addresses/Addresses-types";
import { useModal } from "../../Shared/components/Modal";
import { AddUpdateAddressForm_ContextModals } from "./AddUpdateAddressForm_ContextModals";
/**
 * * UPDATE ADDRESS CONTEXT MODAL
 * @returns Show modal function.
 */
export const useAddUpdateAddressModal = (refetchAddresses, deliveryQuestions, geoLocationCoords, address) => {
    const { showModal, closeModal } = useModal();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    return {
        /**
         *
         * @param refetchAddresses Function to refetch (and update the view) of the current addresses.
         * @param deliveryQuestions See address types: MealTrackOption2\MealTrackOption2\Scripts\react\Addresses\Addresses-types.ts.
         * @param geoLocationCoords Mapbox function.
         * @param address See address types: MealTrackOption2\MealTrackOption2\Scripts\react\Addresses\Addresses-types.ts/
         * @returns
         */
        showAddUpdateAddressModal: () => showModal({
            title: address ? AddressesText.UPDATE_ADDRESS : AddressesText.ADD_ADDRESS,
            content: (_jsx(AddUpdateAddressForm_ContextModals, { refetchAddresses: refetchAddresses, deliveryQuestions: deliveryQuestions, address: address, closeModal: closeModal, geoLocationCoords: geoLocationCoords, formId: "AddUpdateAddressForm" })),
            maxWidth: "md",
            fullScreen: isMobile,
            fullWidth: true,
        }),
    };
};
